import * as income from './Income';
import * as expense from './Expense';
import * as links from './Links';

export const route = {
  path: 'invoices',
  children: [income.route, expense.route, links.route],
};
